import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepOneLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepOneLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.discoverStepOneLevels.data.discoverStepOneLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
